module.exports = __webpack_public_path__ + "img/document.90a551c8.svg";